import { FC, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { calculateAndDispatchUpdates } from 'newelements/_Betslip/utils/action-middlewares/store-actions-middlewares/calculateAndDispatchUpdates';
import { getAllBetIds } from 'store/selectors/betslip';
import { getIsLoggedIn } from 'store/selectors/user-data';

export const CounterOfferManager: FC = () => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const allBetIds = useSelector(getAllBetIds);

  useLayoutEffect(() => {
    if (!isLoggedIn) {
      allBetIds.forEach(id => {
        calculateAndDispatchUpdates({ id, superBet: false, oddOffer: null });
      });
    }
  }, [isLoggedIn, allBetIds]);

  return null;
};
